import { createSlice } from '@reduxjs/toolkit';
import {
  deleteInstallation,
  fetchInstallationHistoryData,
} from '../../services/installationHistory/InstallationHistoryService';

interface InstallationHistoryState {
  installationHistory: {
    data: any[];
    loading: boolean;
    error: string | null;
  };
  deleteInstallation: {
    data: undefined;
    loading: boolean;
    error: string | null;
  };
}

const initialState: InstallationHistoryState = {
  installationHistory: {
    data: [],
    loading: false,
    error: null,
  },
  deleteInstallation: {
    data: undefined,
    loading: false,
    error: null,
  },
};

const installationHistorySlice = createSlice({
  name: 'installationHistory',
  initialState,
  reducers: {
    setInstallationHistory: (state, action) => {
      state.installationHistory.data = action.payload;
      state.deleteInstallation = { data: undefined, loading: false, error: null };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchInstallationHistoryData.pending, (state) => {
      state.installationHistory.loading = true;
      state.installationHistory.error = null;
    });
    builder.addCase(fetchInstallationHistoryData.fulfilled, (state, action) => {
      state.installationHistory.loading = false;
      state.installationHistory.data = action.payload;
    });
    builder.addCase(fetchInstallationHistoryData.rejected, (state, action) => {
      state.installationHistory.loading = false;
      state.installationHistory.error = action.error?.message || 'Failed to fetch installation history';
    });

    // deleteInstallation
    builder.addCase(deleteInstallation.pending, (state) => {
      state.deleteInstallation.loading = true;
      state.deleteInstallation.error = null;
    });
    builder.addCase(deleteInstallation.fulfilled, (state, action) => {
      state.deleteInstallation.loading = false;
      if (action.meta && action.meta.arg) {
        state.installationHistory.data = state.installationHistory.data.filter(
          (item: any) => item.Id !== Number(action.meta.arg),
        );
      }
    });
    builder.addCase(deleteInstallation.rejected, (state, action) => {
      state.deleteInstallation.loading = false;
      state.deleteInstallation.error = action.error?.message || 'Delete failed';
    });
  },
});

export const { setInstallationHistory } = installationHistorySlice.actions;
export default installationHistorySlice.reducer;
